import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { CarouselComponent, OwlOptions } from 'ngx-owl-carousel-o';
import { MainCardData } from 'src/app/shared/interfaces/cards/main-card.interface';

@Component({
  selector: 'home-slider',
  template: `
    <div class="slider-container position-relative" #carouselWrapper>
      <owl-carousel-o [options]="customOptions" (initialized)="onInitialized($event)" #owlCarousel>
        <ng-container *ngFor="let slide of slides">
          <ng-template carouselSlide>
            <main-card [info]="slide"></main-card>
          </ng-template>
        </ng-container>
      </owl-carousel-o>

      <!-- Custom navigation buttons -->
      <div class="slider-nav-buttons">
        <button class="slider-nav-button slider-nav-prev" (click)="prevSlide()">
          <i class="fa fa-chevron-left"></i>
        </button>
        <button class="slider-nav-button slider-nav-next" (click)="nextSlide()">
          <i class="fa fa-chevron-right"></i>
        </button>
      </div>
    </div>
  `,
  styles: [`
    .slider-container {
      width: 100%;
      position: relative;
    }

    .slider-nav-buttons {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      pointer-events: none;
    }

    .slider-nav-button {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 50px;
      height: 50px;
      background: rgba(255, 255, 255, 0);
      border: none;
      border-radius: 50%;
      color: white;
      font-size: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      pointer-events: auto;
      z-index: 10;
      transition: all 0.3s ease;
    }

    .slider-nav-button:hover {
      background: rgba(0, 0, 0, 0.8);
    }

    .slider-nav-prev {
      left: 20px;
    }

    .slider-nav-next {
      right: 20px;
    }

    /* Display navigation buttons on mobile */
    @media (max-width: 768px) {
      .slider-nav-buttons {
        display: flex;
        justify-content: space-between;
        align-items: center;
        pointer-events: auto;
      }

      .slider-nav-prev,
      .slider-nav-next {
        top: auto;
        transform: none;
        width: 40px;
        height: 40px;
        font-size: 20px;
      }

      .slider-nav-prev {
        left: 10px;
      }

      .slider-nav-next {
        right: 10px;
      }
    }
  `],
})
export class HomeSliderComponent {
  @Input() slides: MainCardData[] = [];
  @ViewChild('owlCarousel', { static: false }) owlCarousel!: CarouselComponent;
   @ViewChild('carouselWrapper', { static: false }) carouselWrapper!: ElementRef;

  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 1000,
    responsive: {
      0: {
        items: 1
      }
    },
    nav: false,
    autoplay: true,
    autoplayTimeout: 7000,
    autoplayHoverPause: true,
    animateOut: 'waveOut',
    animateIn: 'waveIn',
  };

  onInitialized(event: any) {
    this.owlCarousel = event.component;
  }

  nextSlide() {
    if (this.owlCarousel) {
      this.owlCarousel.next();
    }
  }

  prevSlide() {
    if (this.owlCarousel) {
      this.owlCarousel.prev();
    }
  }
   ngAfterViewInit() {
  const el = this.carouselWrapper.nativeElement;

  const pauseAutoplay = () => {
    // Fix: proper way to stop autoplay
    this.owlCarousel.stopAutoplay();
  };

  const resumeAutoplay = () => {
    // Fix: proper way to start autoplay
    this.owlCarousel.startAutoplay();
  };

  // Desktop hover pause (already handled by autoplayHoverPause, but just in case)
  el.addEventListener('mouseenter', pauseAutoplay);
  el.addEventListener('mouseleave', resumeAutoplay);

  // Mobile touch pause
  el.addEventListener('touchstart', pauseAutoplay);
  el.addEventListener('touchend', resumeAutoplay);
}
}
